import { createContext, useContext } from 'react';

export const SubscriptionContext = createContext({
  planFeatures: null,
  loading: true,
  refreshSubscriptionFeatures: () => {},
});

export const useSubscriptionFeatures = () => useContext(SubscriptionContext);
